import * as React from "react";

import {
    MatchObject,
    ResultData,
    SearchEngine
} from "app/services/data-loader/search-engine.service";
import MenuItem from "@mui/material/MenuItem";
import ListSubheader from "@mui/material/ListSubheader";
import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom";
import { NavigateService } from "app/services/navigate.service";

import "./search-results.less";

interface IComponentProps {
    results?: ResultData;
}

export class SearchResults extends React.Component<IComponentProps> {
    constructor(props: IComponentProps) {
        super(props);
        this.state = {};
    }

    performUnlimitedSearch = async () => {
        const results = this.props.results;
        const options = (results && results.options) || {};
        options.limit = 0;
        if (results) {
            SearchEngine.search(results.key, options);
        }
    };

    render(): React.JSX.Element | null {
        const results = this.props.results;
        if (!results) {
            return null;
        }

        const matches = results.matches ? results.matches : [];

        return (
            <section className="search-column">
                <h3 className="mr-auto">Search results for ‘{results.key}’</h3>

                <div>
                    {results.message}
                    {!results.limited ? (
                        ""
                    ) : (
                        <>
                            &nbsp;
                            <small className="hoverPointer" onClick={this.performUnlimitedSearch}>
                                [show all]
                            </small>
                        </>
                    )}
                </div>

                {this.renderGroups(matches)}
            </section>
        );
    }

    renderGroups(matches: MatchObject[]) {
        const matchesPerGroup = SearchEngine.getMatchesPer("groupText", matches);
        return matchesPerGroup.map(([groupText, groupItems], index: number) => (
            <React.Fragment key={groupText}>
                <ListSubheader>{groupText}</ListSubheader>
                {groupItems.map((item: any, index) => (
                    <MenuItem key={groupText + "-" + item.iri + "-" + index}>
                        <Link
                            to={NavigateService.getBrowseLink(item.iri)}
                            className="dropdown-item search-result-item"
                            style={{ textDecoration: "none", color: "inherit", width: "100%" }}
                        >
                            {item.name || item.iri}
                        </Link>
                    </MenuItem>
                ))}
                {/* Do not render divider for the last item */}
                {index < matchesPerGroup.length - 1 && <Divider />}
            </React.Fragment>
        ));
    }
}
